export default __webpack_public_path__ + "static/media/wb.9af312e9.jpg";